export const initialPermissions = {
	analytics: false,
	app_settings: {
		manage_settings: false,
		manage_order_settings: false,
		manage_inventory_settings: false,
		manage_site_settings: false,
		manage_reminder_settings: false,
		manage_cart_retention: false,
		manage_change_parts: false,
		allow_model_uploads: false,
		manage_price_markups: false,
		manage_default_values: false,
	},
	document_management: {
		create_documents: false,
		edit_documents: false,
		delete_documents: false,
	},
	machine_provision_management: {
		provision_machines: false,
		edit_provisions: false,
		delete_provisions: false,
	},
	order_management: {
		create_order: false,
		view_order_history: false,
		create_order_schedules: false,
		edit_order_schedules: false,
		delete_order_schedules: false,
	},
	recommendations_management: {
		create_list: false,
		edit_list: false,
		delete_list: false,
		add_parts: false,
	},
	requests_management: {
		allow_notify_customer_care: false,
		view_request_history: false
	},
	role_management: {
		create_roles: false,
		edit_roles: false,
		delete_roles: false,
	},
	site_management: {
		edit_sites: false,
	},
	service_management: {
		view_cases: false,
		view_workorders: false,
		create_cases: false,
	},
	user_management: {
		assignable_role_types: ["User"],
		view_scope: "all",
		edit_scope: "created_by_me",
		delete_scope: "created_by_me",
		site_allocation_scope: "specific_only",
		domain_user_management_scope: "approved_domains_only",
		can_view_pending_users_for_approval: false,
		create_users: false,
		edit_users: false,
		delete_users: false,
	},
    profile: {
        allow_password_reset: false,
        allow_notification_preferences: false,
    },
};
